import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { BrandType, makeNewTemplate } from 'globals/store/publish.data';
import { Wrapper } from '../wrapper.component';
import { JoiAccount } from 'globals/store/accounts.data';
import { CommonModule } from '@angular/common';
import { BrandTemplateComponent } from './brand-template.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'template-editor',
    template: `
<brand-template 
  [readOnly]="true"
  [selected]="!selectedId || selectedId === 'joi'"
  [onAccount]="onAccount"
  [ngClass]="{ selected: !selectedId || selectedId === 'joi' }"
  (setAsAccountDefault)="readOnly ? null : setAsAccountDefault.emit('joi')"
  (select)="select.emit('joi')"
  [isAccountDefault]="!(account.templates | findById:account.templateId) || account.templateId === 'joi'"
></brand-template>
<brand-template 
  *ngFor="let template of account.templates" 
  [template]="template" 
  [readOnly]="readOnly"
  [selected]="selectedId === template.id"
  [onAccount]="onAccount"
  [ngClass]="{ selected: selectedId === template.id }"
  [isAccountDefault]="account.templateId === template.id"
  (setAsAccountDefault)="readOnly ? null : setAsAccountDefault.emit(template.id)"
  (select)="select.emit(template.id)"
  (delete)="deleteTemplate(template.id)"
  (updateTemplate)="updateTemplates()"
></brand-template>
<button mat-button class="large" *ngIf="!readOnly" (click)="addTemplate()">+ Add a template</button>
`,
    styles: [`
  brand-template { margin-bottom: 20px; }
`],
    standalone: true,
    imports: [CommonModule, MatButtonModule, BrandTemplateComponent, FindByIdPipe],
})
export class TemplateEditorComponent extends Wrapper<TemplateEditorComponent> {
  @Input() readOnly: boolean
  @Input() selectedId: string
  @Input() onAccount: boolean
  @Input() account: Partial<JoiAccount>
  @Input() type: BrandType = 'forms'

  @Output() select: EventEmitter<string> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<string> = new EventEmitter()

  constructor() {
    super()
  }
  

  addTemplate() {
    const templates = this.account.templates
    templates.push(makeNewTemplate())
    this.accountService.updateAccount(this.account.id, { templates }, { file: 'template-editor.component.ts', function: 'addTemplate', error: new Error(), message: 'There was an error adding a template' })
  }

  deleteTemplate(deleteId: string) {
    const templates = this.account.templates.filter(t => t.id !== deleteId)
    this.account.templates = templates
    this.accountService.updateAccount(this.account.id, { templates }, { file: 'template-editor.component.ts', function: 'deleteTemplate', error: new Error(), message: 'There was an error deleting a template' })
  }

  updateTemplates() {
    console.log("Update templates being called!", { templates: this.account.templates })
    this.accountService.updateAccount(this.account.id, { templates: this.account.templates }, { file: 'template-editor.component.ts', function: 'updateTemplates', error: new Error(), message: 'There was an error updating the account templates' })
  }

}

